<div class="flex flex-column gap-3 w-full">
	@if (stores.length > 0) {
		<div class="flex align-items-center my-2 w-full">
			<div class="flex-grow-1 divider-line"></div>
			<span class="px-3 font-bold text-sm">{{ translations['deliveryAvailable'] }}</span>
			<div class="flex-grow-1 divider-line"></div>
		</div>
	} @else {
		<div class="flex align-items-center my-2 w-full">
			<div class="flex-grow-1 divider-line"></div>
			<span class="px-3 font-bold text-sm">{{ translations['noDeliveryAvailable'] }}</span>
			<div class="flex-grow-1 divider-line"></div>
		</div>
	}

	@for (store of stores; track store.slug || $index) {
		<app-store-card
			[store]="store"
			[code]="StoreDeliveryCodeEnum.Delivery"
			[isAvailable]="!!store.deliveryAvailable"
			[translations]="translations"
			(selected)="onSelectStore($event.store, $event.code)"
		></app-store-card>
	}
</div>
